import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";
import UrlBase from "../../url/Urls";
import {
  CoworkerWorkedHoursRequest,
  ProjectProgress,
  RescheduleAdvanceRequest
} from "../../types/project-progress/types";

export const getRequestAdvances = async (
  page: number,
  size: number,
  startDate?: string,
  endDate?: string,
  filter?: string,
  userId?: number
) => {
  let responseData = {};
  const requestBody = {
    page: page,
    size: size ? size : UrlBase.registration_x_page,
    startDate: startDate,
    endDate: endDate,
    filter: filter,
    userId: userId,
  };
  await privateFetch
    .post(
      URL.REQUEST_ADVANCES_FIND_ALL, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      throw new Error("Error en consulta de avances por proyecto");
    });
  return responseData;
};

export const getRequestDetailsAdvances = async (
  page: number,
  size: number,
  projectProgressId: string,
): Promise<ProjectProgress> => {
  try {
    const { data } = await privateFetch.get<ProjectProgress>(
        URL.REQUEST_ADVANCES_FIND_ALL_DETAILS(page, size, projectProgressId)
    );
    return data;
  } catch (error) {
    console.error("Error al consultar los avances del proyecto:", error);
    throw new Error("Error al consultar los avances por proyecto");
  }
};

export const rescheduleAdvance = async (request: RescheduleAdvanceRequest): Promise<ProjectProgress> => {
  try {
    const { data } = await privateFetch.put<ProjectProgress>(
        URL.REQUEST_RESCHEDULE_PROJECTS_PROGRESS,
        request,
        {
          headers: {
            ...CONSTANT.HEADER_TYPE,
          },
        });
    return data;
  } catch (error: any) {
    const message: string = error.response?.data?.error ?? "Error al cambiar la fecha del avance de proyecto";
    throw new Error(message);
  }
}

export const createAdvance = async (
  data: any,
) => {
  const requestBody = {
    year: data.year,
    week: data.week,
    projectId: data.projectId,
    user: data.user,
    notes: "",
  };
  let responseData = {};
  await privateFetch
    .post(
      URL.REQUEST_CREATE_ADVANCE, JSON.stringify(requestBody), {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      if(typeof error?.response?.data?.message === "string"){
        throw new Error(error.response.data.message);
      }
      throw new Error("Error en creación de avance");
    });
  return responseData;
};

export const deleteAdvanceRequest = async (data: any) => {
  console.log(data)
  let responseData = {};
  const requestBody = {
    positionId: data.positionId,
    personId: data.id,
    progressId: data.advanceId
  };
  await privateFetch
    .delete(URL.REQUEST_DELETE_COWORKER_ADVANCE, { data: requestBody })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en proceso de eliminar boleta");
    });
  return responseData;
};

export const updateAllWeeklyPayrollPayments = async (
    request: CoworkerWorkedHoursRequest[]
): Promise<ProjectProgress> => {
  try {
    const response = await privateFetch.put<ProjectProgress>(
        URL.REQUEST_UPDATE_ALL_WEEKLY_PAYROLL_PAYMENT,
        request,
        {
          headers: {
            ...CONSTANT.HEADER_TYPE,
          },
        }
    );
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || error.message || 'Error desconocido';
    throw new Error(`No se pudo procesar los pagos semanales del colaborador: ${message}`);
  }
};

export const deleteCompleteAdvanceRequest = async (id: any) => {
  let responseData = {};
  const requestBody = {
    id: id
  };
  await privateFetch
    .delete(URL.REQUEST_DELETE_ALL_ADVANCE, { data: requestBody })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error("Error en proceso de eliminar el avance");
    });
  return responseData;
};

export const getRequestAdvanceCSSReport = async (id: number): Promise<void> => {
  try {
    const url = `${UrlBase.base_url}${UrlBase.api_context}${URL.REQUEST_ADVANCE_CSS_REPORT(id)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error al descargar el archivo. Código: ${response.status}`);
    }

    // Obtener el Blob de la respuesta
    const blob = await response.blob();

    // Forzar el tipo MIME correcto para Excel
    const excelBlob = new Blob([blob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear un enlace temporal para descargar el archivo
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(excelBlob);
    link.download = ""; // Nombre del archivo con extensión .xlsx
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error: any) {
    console.error("Error al descargar el archivo:", error.message);
    throw new Error("Error al obtener el reporte de CSS del avance");
  }
};

export const getRequestAdvanceMonthReport = async (month: any, year: any): Promise<void> => {
  try {
    const url = `${UrlBase.base_url}${UrlBase.api_context}${URL.REQUEST_ADVANCE_MONTH_REPORT(month, year)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error al descargar el archivo. Código: ${response.status}`);
    }

    // Obtener el Blob de la respuesta
    const blob = await response.blob();

    // Forzar el tipo MIME correcto para Excel
    const excelBlob = new Blob([blob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear un enlace temporal para descargar el archivo
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(excelBlob);
    link.download = ""; // Nombre del archivo con extensión .xlsx
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error: any) {
    console.error("Error al descargar el archivo:", error.message);
    throw new Error("Error al obtener el reporte de CSS del avance");
  }
};

export const getRequestAdvanceProjectProgressReport = async (projectId: any, size: number = 10, page: number = 0): Promise<void> => {
  try {
    const url = `${UrlBase.base_url}${UrlBase.api_context}${URL.REQUEST_ADVANCE_PROJECT_PROGRESS_REPORT(projectId, size, page)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error al descargar el archivo. Código: ${response.status}`);
    }

    // Obtener el Blob de la respuesta
    const blob = await response.blob();

    // Forzar el tipo MIME correcto para Excel
    const excelBlob = new Blob([blob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear un enlace temporal para descargar el archivo
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(excelBlob);
    link.download = `Reporte_Avance_Proyecto_${projectId}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error: any) {
    console.error("Error al descargar el archivo:", error.message);
    throw new Error("Error al obtener el reporte de avance del proyecto");
  }
};


export interface WeeklyPayrollDetailReport {
  header: {
    year: number;
    week: number;
    dateRange: string;
  };
  details: {
    personId: number;
    name: string;
    ibanAccount: string;
    bankName: string;
    grossSalary: number;
    ccssAmount: number;
    creditDebitAmount: number;
    netSalary: number;
    transportationPaymentAmount: number;
  }[];
  totalElements: number;
  totalPages: number;
}

export interface MonthlyPlanillaReport {
  weekHeaders: string[];
  persons: {
    id: number;
    name: string;
    weeklyAmounts: (number | null)[];
    total: number;
  }[];
  totalElements: number;
  totalPages: number;
}

export const getWeeklyPayrollDetailReport = async (
  year: number,
  week: number,
  size: number,
  page: number,
  filter?: string
): Promise<WeeklyPayrollDetailReport> => {
  try {
    const { data } = await privateFetch.get<WeeklyPayrollDetailReport>(
      URL.REQUEST_ADVANCE_WEEKLY_PAYROLL_DETAIL_REPORT(year, week, size, page, filter)
    );
    return data;
  } catch (error) {
    throw new Error("Error al consultar el informe semanal");
  }
};

export const getMonthlyPlanillaReport = async (
  year: number,
  month: number,
  size: number,
  page: number,
  filter?: string
): Promise<MonthlyPlanillaReport> => {
  try {
    const { data } = await privateFetch.get<MonthlyPlanillaReport>(
      URL.REQUEST_ADVANCE_MONTHLY_PLANILLA_REPORT(year, month, size, page, filter)
    );
    return data;
  } catch (error) {
    throw new Error("Error al consultar el informe mensual de planillas");
  }
};

export const getWeeklyPayrollExcelReport = async (year: number, week: number, filter?: string): Promise<void> => {
  try {
    const url = `${UrlBase.base_url}${UrlBase.api_context}${URL.REQUEST_ADVANCE_WEEKLY_PAYROLL_EXCEL_REPORT(year, week, filter)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error al descargar el archivo. Código: ${response.status}`);
    }

    const blob = await response.blob();
    const excelBlob = new Blob([blob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(excelBlob);
    link.download = `Informe_Semanal_${year}_Semana${week}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error: any) {
    console.error("Error al descargar el archivo:", error.message);
    throw new Error("Error al obtener el informe semanal en Excel");
  }
};

export const getMonthlyPlanillaExcelReport = async (year: number, month: number, filter?: string): Promise<void> => {
  try {
    const url = `${UrlBase.base_url}${UrlBase.api_context}${URL.REQUEST_ADVANCE_MONTHLY_PLANILLA_EXCEL_REPORT(year, month, filter)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error al descargar el archivo. Código: ${response.status}`);
    }

    const blob = await response.blob();
    const excelBlob = new Blob([blob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(excelBlob);
    link.download = `Informe_Planilla_${year}_${month}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error: any) {
    console.error("Error al descargar el archivo:", error.message);
    throw new Error("Error al obtener el informe mensual de planillas en Excel");
  }
};

export const validateHours = async (data: any) => {
  // Construir los parámetros de la URL
  const queryParams = new URLSearchParams({
    personId: data.personId,
    year: data.year,
    week: data.week,
    mondayHours: data.mondayHours,
    tuesdayHours: data.tuesdayHours,
    wednesdayHours: data.wednesdayHours,
    thursdayHours: data.thursdayHours,
    fridayHours: data.fridayHours,
    saturdayHours: data.saturdayHours,
    sundayHours: data.sundayHours,
  }).toString();

  let responseData = {};

  await privateFetch
    .get(`${URL.REQUEST_PROJECTS_VALIDATE_HOURS(queryParams)}`, {}) // Usar la URL con los parámetros
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch((error) => {
      throw new Error("Error en validación de horas");
    });

  return responseData;
};

